<template>
    <div class="app-container" style="height: 100%">
        <page-layout :footer-box-shadow="false">
            <div style="max-width: 100%">
                <network-connection-info
                    :contact-id="contactId"
                    :live-url="proposal.contact.live_url"
                    :campaign-id="campaign.id"
                    :proposal-id="proposal.id"
                    :network-id="networkId"
                    :instagram-graph-required="instagramGraphRequired"
                    @go-back="handleConnected"
                    @show-instagram-faq="handleInstagramFaq"
                />
            </div>

            <template #footer>
                <g-typography tag="p" text-align="center" size="small">
                    <span v-if="networkId === INSTAGRAM_ID && !useThirdParty">
                        Need Help? <a @click="handleInstagramFaq">Read our FAQ's</a>
                    </span>
                    <span v-else-if="helpDocLink">
                        Learn more about connecting at
                        <a :href="helpDocLink" target="_blank">GRIN Help</a>.
                    </span>
                </g-typography>
                <div style="text-align: center">
                    <powered-by-grin />
                </div>
            </template>
        </page-layout>
    </div>
</template>

<script>
    import { getMeta } from '../../../../src/helpers';
    import { INSTAGRAM_ID, TIKTOK_ID, PINTEREST_ID } from '../../../constants/networks';
    import { FAQ_CONNECTING_TIKTOK, FAQ_CONNECTING_PINTEREST } from '../../../constants/faqs';
    import PageLayout from '../../layouts/PageLayout.vue';
    import NetworkConnectionInfo from './partials/NetworkConnectionInfo.vue';
    import NetworkConnectionMixin from '../../../mixins/NetworkConnectionMixin';
    import { useFeatureFlagsStore } from '../../../../stores';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'ConnectNetworkView',

        data() {
            return {
                INSTAGRAM_ID
            };
        },

        /**
         * The component properties
         *
         * @type {object}
         */
        props: {
            campaign: {
                type: Object,
                default: null
            },
            proposal: {
                type: Object,
                default: null
            },
            contactId: {
                type: String,
                required: true
            },
            networkId: {
                type: Number,
                default: null
            }
        },

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [NetworkConnectionMixin],

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            NetworkConnectionInfo,
            PageLayout
        },

        /**
         * The computed properties
         *
         * @type {object}
         */
        computed: {
            /**
             * The root host
             *
             * @returns {string}
             */
            host() {
                return getMeta('routing-domain');
            },

            helpDocLink() {
                const links = {
                    [TIKTOK_ID]: FAQ_CONNECTING_TIKTOK,
                    [PINTEREST_ID]: FAQ_CONNECTING_PINTEREST
                };

                return [TIKTOK_ID, PINTEREST_ID].includes(this.networkId) ? links[this.networkId] : null;
            },

            useThirdParty() {
                return true;
            }
        },

        /**
         * The component methods
         *
         * @type {Object}
         */
        methods: {
            /**
             * Handle FAQ link click
             */
            handleInstagramFaq() {
                this.$router.push({ name: 'v2.campaign.proposal.networks.faq' });
            },

            /**
             * Handle a successful connection
             */
            handleConnected() {
                this.$router.push({
                    name: 'v2.campaign.proposal.networks',

                    query: {
                        connectedNetworkId: this.networkId
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-normal {
        margin-bottom: 1rem;
    }
</style>
